import { view } from '@yola/ws-sdk';
import targetTypes from '../constants/target-types';
import { breakpointKeys } from '../constants/breakpoints';
import combineBatches from './combine-batches';
import getTargetType from './get-target-type';
import { readClassValues } from './handle-class-token';

const getElementAttributeValue = (elementId, attribute) => {
  const hasAttribute = view.verifiers.hasElementAttribute(elementId, attribute);
  const value = hasAttribute
    ? view.accessors.getElementAttribute(elementId, attribute) || true
    : false;

  return { [breakpointKeys.DEFAULT]: value };
};

const getTargetValue = (elementId, target) =>
  getTargetType(target) === targetTypes.CLASS
    ? readClassValues({ element: view.accessors.getStaticElement(elementId), target })
    : getElementAttributeValue(elementId, target);

const generateInitialState = (settings) => {
  const batches = settings.map(({ elementIds = [], targets = [] }) => {
    const batch = {};

    elementIds.forEach((elementId) => {
      targets.forEach((target) => {
        const value = getTargetValue(elementId, target);

        if (!Object.keys(value).length) {
          return;
        }

        if (!batch[elementId]) {
          batch[elementId] = {};
        }

        batch[elementId][target] = value;
      });
    });

    return batch;
  });

  return combineBatches(batches);
};

export default generateInitialState;
